// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"257":"57712e92","453":"6ee3972d"}[chunkId] + ".chunk.js";
};